'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaTeamInviteAcceptCtrl', function ($state) {
  $state.go('public.signin');
});
